import React from 'react';
import { useHistory } from 'react-router-dom';

import ButtonGroup from '@swf/components/ButtonGroup/ButtonGroup';
import type { Props as ButtonProps } from '@swf/components/StarsButton/StarsButton';
import StarsButton from '@swf/components/StarsButton/StarsButton';
import type { MultiPurposeNotification } from '@swf/core/types/Notification';

import type { CardAction } from '../../config/NotificationTypes';
import type { NotificationType } from '../../enums';
import { ActionType } from '../../enums';
import { geti18NValueConfig } from '../../utils';

import styles from './Buttons.scss';

export enum GroupVariant {
  Responsive = 'responsive',
  Stacked = 'stacked'
}

interface Props {
  actionList?: CardAction[];
  attributes?: MultiPurposeNotification['attributes'];
  notificationId?: number;
  notificationType?: NotificationType;
  primaryVariant?: ButtonProps['variant'];
  secondaryVariant?: ButtonProps['variant'];
  groupVariant?: GroupVariant;
  close?(s: string): void;
  onClickPrimaryAction?(): void;
  onClickSecondaryAction?(): void;
}

const Buttons: React.FC<Props> = ({
  actionList = [],
  notificationType,
  attributes,
  notificationId,
  onClickPrimaryAction,
  onClickSecondaryAction,
  primaryVariant = 'primary',
  secondaryVariant = 'secondary',
  groupVariant = GroupVariant.Responsive
}) => {
  const history = useHistory();
  const buttonElements = actionList.map((actionCfg, idx) => {
    const buttonStyle =
      actionCfg.actionType === ActionType.Primary ? primaryVariant : secondaryVariant;
    const {
      actionLabel: {
        tag: { id = idx }
      }
    } = actionCfg;
    return (
      <StarsButton
        key={id}
        href={actionCfg.href}
        onClick={() => {
          if (actionCfg.actionFunction) {
            actionCfg.actionFunction({ attributes, notificationId, notificationType, history });
          }
          if (actionCfg.actionType === ActionType.Primary && onClickPrimaryAction) {
            onClickPrimaryAction();
          } else if (actionCfg.actionType === ActionType.Secondary && onClickSecondaryAction) {
            onClickSecondaryAction();
          }
        }}
        block
        variant={buttonStyle}
        translation={actionCfg.actionLabel.tag}
        values={attributes ? geti18NValueConfig(actionCfg.actionLabel.values, attributes) : {}}
      />
    );
  });
  return (
    <ButtonGroup className={`${styles.actionButtons} ${styles[groupVariant]}`}>
      {buttonElements}
    </ButtonGroup>
  );
};
export default Buttons;
